import React, { useState } from 'react';
import { useAuth } from '../AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState('');
  const [caricamento, setCaricamento] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) {
      setErrore('Inserisci username e password');
      return;
    }
    setErrore('');
    setCaricamento(true);
    try {
      await login(username, password);
    } catch (e) {
      if (e.response?.status === 401) {
        setErrore('Credenziali non valide');
      } else if (e.response?.status === 403) {
        setErrore('Utente disattivato');
      } else {
        setErrore('Errore di connessione al server');
      }
      setCaricamento(false);
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f5f5f4'
    }}>
      <div style={{
        background: 'white', borderRadius: 12, padding: '40px 36px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)', width: 360
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="/logo-leggescuola.png" alt="LeggeScuola.it" style={{ width: 180, marginBottom: 4 }} />
          <div style={{ fontSize: 13, color: '#78716c' }}>Sistema AI — Accesso riservato</div>
        </div>

        <label style={{ fontSize: 13, fontWeight: 600, color: '#44403c' }}>Username</label>
        <input
          type="text" value={username} autoFocus
          onChange={e => setUsername(e.target.value)}
          onKeyDown={handleKey}
          style={{
            width: '100%', padding: '10px 12px', marginTop: 4, marginBottom: 16,
            border: '1px solid #d6d3d1', borderRadius: 8, fontSize: 14, boxSizing: 'border-box'
          }}
        />

        <label style={{ fontSize: 13, fontWeight: 600, color: '#44403c' }}>Password</label>
        <input
          type="password" value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={handleKey}
          style={{
            width: '100%', padding: '10px 12px', marginTop: 4, marginBottom: 20,
            border: '1px solid #d6d3d1', borderRadius: 8, fontSize: 14, boxSizing: 'border-box'
          }}
        />

        {errore && (
          <div style={{
            background: '#FEF2F2', border: '1px solid #FECACA', color: '#B91C1C',
            borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 16
          }}>
            {errore}
          </div>
        )}

        <button
          onClick={handleLogin} disabled={caricamento}
          style={{
            width: '100%', padding: '11px', background: '#1c1917', color: 'white',
            border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600,
            cursor: caricamento ? 'wait' : 'pointer', opacity: caricamento ? 0.7 : 1
          }}
        >
          {caricamento ? 'Accesso in corso…' : 'Accedi adesso'}
        </button>
      </div>
    </div>
  );
}
